<template>
  <div id="section-giveaway" class="bg-secondary basic-type text-center text-dark">
    <div class="container-xl">
      <TitleUnderline
        class="text-primary"
        :title="'勤學好禮刮不停'"
      ></TitleUnderline>
      <div class="row">
        <div
          v-for="item in gift"
          :key="item.title"
          class="col-12 col-md-4 give-away d-flex flex-column align-items-center mb-4"
        >
          <div class="bg-circle rounded-circle">
            <img :src="item.image" alt="贈品" class="w-100 h-100 rounded-circle" />
          </div>
          <h5 class="my-4">{{ item.title }}</h5>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center align-items-center mt-5">
        <span class="fs-4 me-2">※</span>
        <p class="mb-0">
          獎品以實物為準，主辦單位保留修改、變更活動內容細節之權利。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gift: [
        {
          title: "LINE POINTS 好禮即享券",
          image: new URL("@/assets/image/gift/gift1.jpg", import.meta.url),
        },
        {
          title: "全聯電子禮卡",
          image: new URL("@/assets/image/gift/gift2.jpg", import.meta.url),
        },
        {
          title: "Apple HomePod mini",
          image: new URL("@/assets/image/gift/gift3.jpg", import.meta.url),
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.give-away {
  .bg-circle {
    height: 230px;
    width: 230px;
  }

  @media (max-width: $md) {
    h5 {
      font-size: 1rem;
    }
  }
}
</style>
